import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';
import FaqItem from './FaqItem';
import style from './style.scss';
import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';
import Customization from '/chat/src/redux/model/customization/model';

class Faq extends Component {
    constructor() {
        super();

        this.state = {
            selectedItemId: '',
            searchInputValue: ''
        }

        this.renderFaqList = this.renderFaqList.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.searchItem = this.searchItem.bind(this);
    }

    render() {
        // NOTE: the input take up 50 px of height, always
        const height = this.props.height - 50 + 'px';
        return (
            <div>
                <div
                    className={style.InputWrapper}
                    style={{backgroundColor: this.props.color}}>
                    <input
                        type='text'
                        placeholder={this.props.language.get("SearchQuestion")}
                        className={style.InputSearch}
                        style={{border: `1px solid ${this.props.color}`}}
                        onInput={this.handleSearch}
                        onClick={this.handleSearch}
                        ref={(inputDOM) => { this.inputDOM = inputDOM;}}>
                    </input>
                    <img
                        src='/common/assets/images/ClientChat_Icon_Search.png'
                        style={{backgroundColor: this.props.color}}
                        className={style.SearchIcon}
                        />
                </div>
                <div className={style.FAQList} style={{height: height}}>
               {this.renderFaqList(this.props.color)}
               </div>
            </div>
        );
    }

    renderFaqList(color) {
        let faqs = this.props.faqs;
        const selectedItemId = this.state.selectedItemId;
        const searchInputValue = this.state.searchInputValue;

        if(searchInputValue){
            faqs = this.searchItem(faqs, searchInputValue);
        }

        if(faqs.length > 0){
            return faqs.map((faq, index) => {
                return (
                    <FaqItem
                        faq={faq}
                        color={color}
                        handleItemClick={this.handleItemClick}
                        selectedItemId={selectedItemId}
                    />
                );
            });
        }else{
            return(
                <div className={style.FAQNotFound}>
                    <div>
                    Inga frågor hittades för sökning
                    </div><div> <b>{searchInputValue}</b></div>
                </div>
            );
        }
    }
    handleItemClick(id) {
        const selectedItemId = this.state.selectedItemId;

        if(selectedItemId === id){
            this.setState({
                selectedItemId: ''
            })
        }else{
            this.setState({
                selectedItemId: id
            })
        }
    }

    handleSearch(e) {
        const faqs = this.props.faqs;
        const value = e.target.value;

        this.setState({
            searchInputValue: value
        })
    }

    searchItem(faqs, searchInputValue) {
        let results = [];
        let idCheck = []; //Id flag for checking doubles
        let match = false;

        faqs.map((faq, index) => {
        const question = faq.question.toUpperCase();
        const answer = faq.answer.toUpperCase();
        const keywords = searchInputValue.split(' ');

            for (let i = 0; i<keywords.length; i++){
                if(question.includes(keywords[i].toUpperCase()) || answer.includes(keywords[i].toUpperCase())){
                    match = true;
                }else{
                    match = false;
                    break;
                }
            }

            if(match && !idCheck.includes(faq.id)){
                results.push(faq);
                idCheck.push(faq.id);
            }
        })
        return results;
    }
}

function mapStateToProps(state) {
    const color = Customization.getColor(state)
    const language = Customization.getLanguage(state)
    const faqs = FeaturesModel.getFeaturePayload(state, 'faq')['faq'];
    return {
        color: color,
        language: language,
        height: SystemModel.getBodyHeight(state),
        faqs: faqs
    };
}

export default connect(mapStateToProps)(Faq);



// WEBPACK FOOTER //
// ./routes/FAQ/Body.js